import React, { memo } from "react";

import Icon from "app/components/Icon/Icon";
import { ReactComponent } from "./svgs/positive_ratio.svg";

export const PositiveRatioIcon = memo(() => {
  return <Icon component={ReactComponent} />;
});
